import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: SPACES.m,
  },

  iconWrapper2: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  button: {
    border: `1px solid ${theme.palette.custom.grey3}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 40,
    width: 40,
    borderRadius: '50%',
    cursor: 'pointer',
    '&&:hover': {
      border: `1px solid ${theme.palette.custom.darkBlue2}`,
    },

    '&&:active': {
      border: `1px solid ${theme.palette.primary.main}`,
    },
  },
}))
